
<template>
    <NavBar />
    <div class="d-flex flex-column">
        <div class="p-2"><h2>Thanks for Subscribing!</h2></div>
        <div class="d-flex justify-content-center"><img alt="Thanks!" src="../../assets/thanks-for-subscribing.png"></div>
        <div class="p-2 .justify-content-md-center">
            Congratulations on your purchase! Get ready to revolutionize your recruitment process with our Ultimate tier subscription. Now, unleash the full potential of SkillSynchrony by sending unlimited assessments to job seekers.
        </div>
    </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue'

import { getCookie } from '@/utils/cookies/cookieUtils';
import { endpoint } from '@/utils/endpoint/endpointUtils';


export default {
  name: 'ThanksForSubscribing',
  components: {
      NavBar,
  },
  async mounted() {

  },
  data() {
    return {

    }
  },
  methods: {
   
  }
}
</script>
<style scoped>
.dashboard {
    margin: 0;
    padding: 0;
    background-color: #181a1b;
}

img {
  display: block;
  max-width: 100%;
  height: auto;
}
</style>